import { useContext } from 'react';
import UserContext from './UserContext.js';

function useCurrentAuth() {
  const { auth } = useContext(UserContext);
  return auth;
}

export default useCurrentAuth;
